import { ProductCharacteristics, ProductCharacteristic, ProductCharacteristicsResp } from './types';

export class ProductC14s implements ProductCharacteristics {
  characteristics?: ProductCharacteristic[];

  constructor(characteristics?: ProductCharacteristic[]) {
    this.characteristics = characteristics;
  }

  public static fromFetchResponse(resp: ProductCharacteristicsResp): ProductCharacteristics {
    const c14s: ProductCharacteristic[] =
      resp.characteristics?.map((item) => {
        const key = Object.keys(item)[0];
        const { value: values, description: term } = item[key];
        const hasOneValue = values.length === 1;
        const definition = hasOneValue ? values[0] : values.join(', ');

        return {
          term,
          definition,
          key,
        };
      }) || [];

    return new ProductC14s(c14s);
  }
}
